import { DOCUMENT } from "@angular/common";
import { Injectable, Inject } from "@angular/core";
import { WINDOW } from "../window.service/window.service";

@Injectable({ providedIn: 'root' })
export class GoogleTagManagerService {

    constructor(@Inject(DOCUMENT) private doc: any, @Inject(WINDOW) private window: any) {
    }

    init(id: string) {
        const s = this.doc.createElement('script');
        s.type = 'text/javascript';
        s.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${id}');
        `;
        const head = this.doc.getElementsByTagName('head')[0];
        head.appendChild(s);
    }

    initDefaultConsent() {
        const script = this.doc.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            // Set consent defaults
            gtag('consent', 'default', {
                analytics_storage: localStorage.getItem('silktideCookieChoice_analytics') === 'true' ? 'granted' : 'denied',
                ad_storage: localStorage.getItem('silktideCookieChoice_marketing') === 'true' ? 'granted' : 'denied',
                ad_user_data: localStorage.getItem('silktideCookieChoice_marketing') === 'true' ? 'granted' : 'denied',
                ad_personalization: localStorage.getItem('silktideCookieChoice_marketing') === 'true' ? 'granted' : 'denied',
                functionality_storage: localStorage.getItem('silktideCookieChoice_necessary') === 'true' ? 'granted' : 'denied',
                security_storage: localStorage.getItem('silktideCookieChoice_necessary') === 'true' ? 'granted' : 'denied'
            });
        `;
        const head = this.doc.getElementsByTagName('head')[0];
        head.appendChild(script);
    }

    initCookieBanner() {
        const bannerConfig = {
            cookieTypes: [
                {
                    id: "necessary",
                    name: $localize`Nécessaire`,
                    description: "<p>" + $localize`Ces cookies sont nécessaires au bon fonctionnement du site web et ne peuvent pas être désactivés. Ils permettent notamment de définir vos préférences de confidentialité.` + "</p>",
                },
                {
                    id: "analytical",
                    name: $localize`Analyse`,
                    description: "<p>" + $localize`Ces cookies nous permettent d'améliorer le site en suivant les pages les plus populaires et le comportement des visiteurs sur le site.` + "</p>",
                }
            ],
            text: {
                banner: {
                    description: "<p>" + $localize`Nous utilisons des cookies sur notre site pour améliorer votre expérience utilisateur, fournir du contenu personnalisé et analyser notre trafic.` + "<a href='https://www.quick-off.com/fr/qoezion/privacy-policy' target='_blank'>" + $localize`Politique de cookies.` + "</a></p>",
                    acceptAllButtonText: $localize`Accepter tous`,
                    acceptAllButtonAccessibleLabel: $localize`Accepter tous les cookies`,
                    rejectNonEssentialButtonText: $localize`Refuser non-essentiel`,
                    rejectNonEssentialButtonAccessibleLabel: $localize`Refuser non-essentiel`,
                    preferencesButtonText: $localize`Préférences`,
                    preferencesButtonAccessibleLabel: $localize`Préférences`
                },
                preferences: {
                    title: $localize`Personnaliser vos préférences de cookies`,
                    description: "<p>" + $localize`Nous respectons votre droit à la vie privée. Vous pouvez choisir de ne pas autoriser certains types de cookies. Vos préférences de cookies s'appliqueront à toutes les pages de notre site web.` + "</p>",
                    creditLinkText: $localize`Obtenir ce bandeau gratuitement`,
                    creditLinkAccessibleLabel: $localize`Obtenir ce bandeau gratuitement`
                }
            }
        };
        const script = this.doc.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = `
            silktideCookieBannerManager.updateCookieBannerConfig({
                background: {
                    showBackground: true
                },
                cookieIcon: {
                    position: "bottomRight"
                },
                cookieTypes: [
                    {
                        id: "necessary",
                        name: "${bannerConfig.cookieTypes[0].name}",
                        description: "${bannerConfig.cookieTypes[0].description}",
                        required: true,
                        onAccept: function() {}
                    },
                    {
                        id: "analytical",
                        name: "${bannerConfig.cookieTypes[1].name}",
                        description: "${bannerConfig.cookieTypes[1].description}",
                        required: false,
                        onAccept: function() {
                            gtag('consent', 'update', {
                                analytics_storage: 'granted',
                            });
                            dataLayer.push({
                            'event': 'consent_accepted_analytical',
                            });
                        },
                        onReject: function() {
                            gtag('consent', 'update', {
                                analytics_storage: 'denied',
                            });
                        }
                    }
                ],
                text: {
                    banner: {
                        description: "${bannerConfig.text.banner.description}",
                        acceptAllButtonText: "${bannerConfig.text.banner.acceptAllButtonText}",
                        acceptAllButtonAccessibleLabel: "${bannerConfig.text.banner.acceptAllButtonAccessibleLabel}",
                        rejectNonEssentialButtonText: "${bannerConfig.text.banner.rejectNonEssentialButtonText}",
                        rejectNonEssentialButtonAccessibleLabel: "${bannerConfig.text.banner.rejectNonEssentialButtonAccessibleLabel}",
                        preferencesButtonText: "${bannerConfig.text.banner.preferencesButtonText}",
                        preferencesButtonAccessibleLabel: "${bannerConfig.text.banner.preferencesButtonAccessibleLabel}"
                    },
                    preferences: {
                        title: "${bannerConfig.text.preferences.title}",
                        description: "${bannerConfig.text.preferences.description}",
                        creditLinkText: "${bannerConfig.text.preferences.creditLinkText}",
                        creditLinkAccessibleLabel: "${bannerConfig.text.preferences.creditLinkAccessibleLabel}"
                    }
                }
            });
        `;
        const head = this.doc.getElementsByTagName('head')[0];
        head.appendChild(script);
    }

    logPageView(url: string) {
        if(this.window.dataLayer) {
            this.window.dataLayer.push({
                event: 'page',
                pageName: url
            });
        }
    }

}
